import { StyleSheet, css } from "aphrodite";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import ReactPaginate from "react-paginate";

import { COLORS } from "~/config/themes";
import { faCaretLeft, faCaretRight } from "@fortawesome/pro-solid-svg-icons";

const PaginationControls = (props) => {
  const pageCount = () => {
    return Math.ceil(props.total / props.limit);
  };
  return (
    <ReactPaginate
      previousLabel={
        <>
          <span className={css(styles.desktopNav)}>Previous</span>
          <FontAwesomeIcon
            icon={faCaretLeft}
            className={css(styles.caret, styles.mobileNav)}
          />
        </>
      }
      nextLabel={
        <>
          <span className={css(styles.desktopNav)}>Next</span>
          <FontAwesomeIcon
            icon={faCaretRight}
            className={css(styles.caret, styles.mobileNav)}
          />
        </>
      }
      breakLabel={"..."}
      breakClassName={css(styles.break)}
      pageCount={pageCount()}
      forcePage={props.page}
      marginPagesDisplayed={props.margin ? props.margin : 1}
      pageRangeDisplayed={props.pageRange ? props.pageRange : 3}
      onPageChange={(pagination) => props.handlePaginationClick(pagination)}
      containerClassName={
        css(styles.paginateContainer) + " agent-search-pagination"
      }
      activeClassName={css(styles.activePage)}
      pageClassName={css(styles.page)}
      pageLinkClassName={css(styles.pageLink)}
      previousLinkClassName={css(styles.navButton, styles.previous)}
      nextLinkClassName={css(styles.navButton, styles.next)}
      showCenterPage={props.showCenterPage ? props.showCenterPage : false}
      hrefBuilder={props.hrefBuilder}
    />
  );
};

const styles = StyleSheet.create({
  paginateContainer: {
    display: "flex",
    listStyleType: "none",
    // justifyContent: "space-between",
    alignItems: "center",
    color: COLORS.BLACK(),
    fontSize: 16,
    fontWeight: 600,
    paddingLeft: 0,
    margin: 0,
  },
  page: {
    width: 42,
    height: 42,

    "@media only screen and (max-width: 767px)": {
      width: 40,
      height: 40,
    },

    "@media only screen and (max-width: 374px)": {
      width: 36,
      height: 36,
    },
  },
  pageLink: {
    width: "100%",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    outline: "none",
    cursor: "pointer",
  },
  activePage: {
    background: COLORS.PRIME_BLUE(),
    color: "#fff",
  },
  navButton: {
    outline: "none",
    cursor: "pointer",
  },
  mobileNav: {
    "@media only screen and (min-width: 768px)": {
      display: "none",
      visibility: "hidden",
    },
  },
  desktopNav: {
    "@media only screen and (max-width: 767px)": {
      display: "none",
      visibility: "hidden",
    },
  },
  caret: {
    fontSize: 24,
  },
});

export default PaginationControls;
